// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"vJ","searchLabel":"vK","searchInput":"vL","searchInner":"vM","searchCross":"vN","searchWrapperFocus":"vO","hide":"vP"};